<template>
    <div class="reservations">
        <div class="page_header">
            <div class="page_header--title">
                Мои записи
            </div>
            <div class="page_header--control">
                <div class="items_navs">
                    <div
                        class="items_nav"
                        :class="{active: activeTab === 'active'}"
                        @click="this.$store.commit('SET_RESERVATIONS_TAB', 'active')">
                        Ближайшие
                    </div>
                    <div
                        class="items_nav"
                        :class="{active: activeTab === 'finished'}"
                        @click="loadFinishedEvents(); this.$store.commit('SET_RESERVATIONS_TAB', 'finished')">
                        Прошедшие
                    </div>
                </div>
            </div>
        </div>

        <div class="page_content">
            <div class="items_tabs">
                <div
                    class="items_tab"
                    :class="{active: activeTab === 'active'}"
                >
                    <reservation-list :events="events" />
                </div>
                <div
                    class="items_tab"
                    :class="{active: activeTab === 'finished'}"
                >
                    <reservation-list :events="finishedEvents" column-count="2" empty-text="Ничего не найдено" />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import ReservationList from "../components/ReservationList";

    export default {
        name: 'Reservations',
        components: {ReservationList },
        computed: {
            events: function() {
                return this.$store.getters.reservations
            },
            finishedEvents: function() {
                return this.$store.getters.finishedReservations
            },
            activeTab: function () {
                return this.$store.getters.reservationsTab
            }
        },
        methods: {
            loadFinishedEvents(){
                if (this.$store.getters.finishedReservations.length === 0){
                    this.$store.dispatch('loadFinishedReservations')
                }
            }
        },
        created() {
            if (this.$store.getters.reservations.length === 0){
                this.$store.dispatch('loadReservations')
            }
        }
    }
</script>
